import { createContext, useReducer, Dispatch } from 'react';

import { Client } from 'braintree-web';
import { Stripe } from '@stripe/stripe-js';
import { ScriptProviderProps } from '@paypal/react-paypal-js';

interface ProvidersLibsState {
  braintreeClient?: Client,
  stripePromise?: Promise<Stripe | null>,
  paypalOptions?: ScriptProviderProps['options'],
}

export const ProvidersLibsContext = createContext<ProvidersLibsState>({});

function providersLibsReducer(state: ProvidersLibsState, action: Partial<ProvidersLibsState>) {
  return {
    ...state,
    ...action,
  };
}

export const ProvidersLibsDispatchContext = createContext<Dispatch<Partial<ProvidersLibsState>>>(() => {});

export const useProvidersLibsReducer = () => (
  useReducer(
    providersLibsReducer,
    {},
  )
);
